var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import EventEmitter from 'events';
import { logger } from './logger';
import { TrackType } from './MediaProvider';
import { SoundMeter } from './SoundMeter';
/**
 * Manages the creation and state-keeping of local
 * media tracks
 */
var MediaLocalTracks = /** @class */ (function (_super) {
    __extends(MediaLocalTracks, _super);
    function MediaLocalTracks(localMicVolumeThreshold) {
        var _a;
        if (localMicVolumeThreshold === void 0) { localMicVolumeThreshold = 0.01; }
        var _this = _super.call(this) || this;
        _this._tracks = (_a = {},
            _a[TrackType.Camera] = null,
            _a[TrackType.Microphone] = null,
            _a[TrackType.Screen] = null,
            _a[TrackType.ScreenAudio] = null,
            _a);
        _this.startCamera = function (deviceId, constraints) {
            if (constraints === void 0) { constraints = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var current, stream, track;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this._tracks[TrackType.Camera]) return [3 /*break*/, 3];
                            current = this._tracks[TrackType.Camera];
                            if (!constraints) return [3 /*break*/, 2];
                            return [4 /*yield*/, current.applyConstraints(constraints)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/, current];
                        case 3:
                            this.emit('trackStarting', TrackType.Camera);
                            return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                    audio: false,
                                    video: __assign({ deviceId: deviceId !== null && deviceId !== void 0 ? deviceId : undefined }, constraints),
                                })];
                        case 4:
                            stream = _a.sent();
                            track = stream.getVideoTracks()[0] || null;
                            this._tracks[TrackType.Camera] = track;
                            track.addEventListener('ended', function () {
                                logger.debug('[LocalTracks] camera track ended');
                                _this._tracks[TrackType.Camera] = null;
                            });
                            return [2 /*return*/, track];
                    }
                });
            });
        };
        _this.stopCamera = function () {
            if (!_this._tracks[TrackType.Camera])
                return;
            _this.emit('trackStopping', TrackType.Camera);
            _this._tracks[TrackType.Camera].stop();
            _this._tracks[TrackType.Camera] = null;
        };
        _this.startMicrophone = function (deviceId, constraints) {
            if (constraints === void 0) { constraints = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var current, stream, track;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this._tracks[TrackType.Microphone]) return [3 /*break*/, 3];
                            current = this._tracks[TrackType.Microphone];
                            if (!constraints) return [3 /*break*/, 2];
                            return [4 /*yield*/, current.applyConstraints(constraints)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/, current];
                        case 3:
                            this.emit('trackStarting', TrackType.Microphone);
                            return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                    audio: {
                                        deviceId: deviceId !== null && deviceId !== void 0 ? deviceId : undefined,
                                    },
                                    video: false,
                                })];
                        case 4:
                            stream = _a.sent();
                            track = stream.getAudioTracks()[0] || null;
                            this._tracks[TrackType.Microphone] = track;
                            track.addEventListener('ended', function () {
                                logger.debug('[LocalTracks] microphone track ended');
                                _this._tracks[TrackType.Microphone] = null;
                                _this._localMicSoundMeter.disconnect();
                            });
                            this._localMicSoundMeter.connectToStream(stream);
                            return [2 /*return*/, track];
                    }
                });
            });
        };
        _this.stopMicrophone = function () {
            if (!_this._tracks[TrackType.Microphone])
                return;
            _this.emit('trackStopping', TrackType.Microphone);
            _this._tracks[TrackType.Microphone].stop();
            _this._tracks[TrackType.Microphone] = null;
            _this._localMicSoundMeter.disconnect();
        };
        _this.startScreenShare = function (constraints) {
            if (constraints === void 0) { constraints = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var stream, screenTrack, screenAudioTrack;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._tracks[TrackType.Screen] && !constraints)) return [3 /*break*/, 1];
                            return [2 /*return*/, {
                                    video: this._tracks[TrackType.Screen],
                                    audio: this._tracks[TrackType.ScreenAudio],
                                }];
                        case 1:
                            if (!(this._tracks[TrackType.Screen] && constraints)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.stopScreenShare()];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this.emit('trackStarting', TrackType.Screen);
                            return [4 /*yield*/, navigator.mediaDevices.getDisplayMedia(__assign({ video: true, audio: true }, constraints))];
                        case 4:
                            stream = _a.sent();
                            screenTrack = stream.getVideoTracks()[0] || null;
                            screenAudioTrack = stream.getAudioTracks()[0] || null;
                            // not ideal to put this here but we don't know whether the user selected
                            // audio or not until the getDisplayMedia is already done...
                            if (screenAudioTrack) {
                                this.emit('trackStarting', TrackType.ScreenAudio);
                            }
                            this._tracks[TrackType.Screen] = screenTrack;
                            this._tracks[TrackType.ScreenAudio] = screenAudioTrack;
                            screenTrack.addEventListener('ended', function () {
                                logger.debug('[LocalTracks] screen track ended');
                                _this._tracks[TrackType.Screen] = null;
                                _this.emit('trackStopping', TrackType.Screen);
                            });
                            screenAudioTrack === null || screenAudioTrack === void 0 ? void 0 : screenAudioTrack.addEventListener('ended', function () {
                                logger.debug('[LocalTracks] screen audio track ended');
                                _this._tracks[TrackType.ScreenAudio] = null;
                                _this.emit('trackStopping', TrackType.ScreenAudio);
                            });
                            return [2 /*return*/, {
                                    video: screenTrack,
                                    audio: screenAudioTrack,
                                }];
                    }
                });
            });
        };
        _this.stopScreenShare = function () {
            var _a;
            if (!_this._tracks[TrackType.Screen])
                return;
            _this.emit('trackStopping', TrackType.Screen);
            _this._tracks[TrackType.Screen].stop();
            if (_this._tracks[TrackType.ScreenAudio]) {
                _this.emit('trackStopping', TrackType.ScreenAudio);
                (_a = _this._tracks[TrackType.ScreenAudio]) === null || _a === void 0 ? void 0 : _a.stop();
            }
            _this._tracks[TrackType.Screen] = null;
            _this._tracks[TrackType.ScreenAudio] = null;
        };
        _this.stopAll = function () {
            _this.stopCamera();
            _this.stopMicrophone();
            _this.stopScreenShare();
        };
        _this._localMicSoundMeter = new SoundMeter(localMicVolumeThreshold);
        _this._localMicSoundMeter.on('thresholdStatusChange', function (exceedsThreshold) {
            _this.emit('localMicVolumeThresholdChange', exceedsThreshold);
        });
        return _this;
    }
    Object.defineProperty(MediaLocalTracks.prototype, "tracks", {
        get: function () {
            return this._tracks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaLocalTracks.prototype, "cameraTrack", {
        get: function () {
            return this._tracks[TrackType.Camera];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaLocalTracks.prototype, "microphoneTrack", {
        get: function () {
            return this._tracks[TrackType.Microphone];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaLocalTracks.prototype, "screenTracks", {
        get: function () {
            return {
                video: this._tracks[TrackType.Screen],
                audio: this._tracks[TrackType.ScreenAudio],
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaLocalTracks.prototype, "screenTrack", {
        get: function () {
            return this._tracks[TrackType.Screen];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaLocalTracks.prototype, "screenAudioTrack", {
        get: function () {
            return this._tracks[TrackType.ScreenAudio];
        },
        enumerable: false,
        configurable: true
    });
    return MediaLocalTracks;
}(EventEmitter));
export { MediaLocalTracks };
//# sourceMappingURL=MediaLocalTracks.js.map